import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'react-toastify';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class AddItem extends Component {
    constructor(props) {
        super(props);
        const info = this.props;

        this.state = {
            name: info.name,
            price: info.price,
            unit: info.unit,
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            name: nextProps.info.name,
            price: nextProps.info.price,
            unit: nextProps.info.unit,
        })
        this.setState({ name: nextProps.info.name, price: nextProps.info.price, unit: nextProps.info.unit, id: nextProps.info.id })
    }
    handleChange = e => {

        this.setState({ [e.target.name]: e.target.value });
    }
    handleClose = () => {
        this.props.closeBox();
    }
    addCard = () => {
        const { name, price, unit } = this.state;
        if (name && name !== "" && price && price !== "" && unit && unit !== "") {
            this.props.addItem( name, price, unit );
            this.props.closeBox();
        } else {
            toast.error("لطفا تمامی مقادیر را وارد نمایید", {
                position: toast.POSITION.BOTTOM_LEFT
            });

        }
    }
    editCard = () => {
        const { id, name, price, unit } = this.state;
        if (name && name !== "" && price && price !== "" && unit && unit !== "") {
            this.props.editItem(id, name, price, unit);
            this.setState({ name: "", price: "", unit: "" })
            this.props.closeBox();
        } else {
            toast.error("لطفا تمامی مقادیر را وارد نمایید", {
                position: toast.POSITION.BOTTOM_LEFT
            });

        }

    }

    render() {
        const { openBox, editedMode } = this.props;
        const { name, unit, price } = this.state;

        return (
            <Dialog
                open={openBox}
                TransitionComponent={Transition}
                keepMounted
                className="add-item"
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title"> {editedMode ? "ویرایش آیتم" : " اضافه کردن آیتم جدید"} </DialogTitle>
                <Grid container space={2}>
                    <Grid item xs={12} lg={3}>
                        <TextField
                            label="عنوان ارز"
                            name="name"
                            value={name}
                            onChange={this.handleChange}
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}

                        />
                    </Grid>
                    <Grid item xs={12} lg={1}></Grid>
                    <Grid item xs={12} lg={3} className="price-item">
                        <TextField
                            label="قیمت ارز"
                            name="price"
                            value={price}
                            onChange={this.handleChange}
                            margin="normal"
                            fullWidth
                            type="number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} lg={1}></Grid>
                    <Grid item xs={12} lg={3}>
                        <FormControl className="">
                            <TextField
                                label="واحد ارز"
                                name="unit"
                                value={unit}
                                onChange={this.handleChange}
                                margin="normal"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <DialogActions>
                    <Button onClick={this.handleClose} className="cancel-btn" color="primary" style={{ marginLeft: 15 }}>
                        انصراف
                    </Button>
                    <Button variant="contained" onClick={editedMode ? this.editCard : this.addCard} color="primary" className="save-btn">
                        {editedMode ? "ویرایش آیتم" : " افزودن آیتم"}

                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default AddItem;